
// DO NOT MODIFY THIS FILE, edit env-config.js file instead
export const environment = {
   production: true, 
   VERSION: "12.0.0"
};


// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/environments/environment.ts